import React from 'react';
import { IoHome } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

type HomeButtonProps = {
	title?: string
}

const HomeButton = ({title}: HomeButtonProps) => {
	const navigate = useNavigate();
	const handleHomeButtonPress = () => navigate('/')
	
	return <HomeButtonContainer onClick={handleHomeButtonPress}>
      <IconContainer><IoHome /></IconContainer>
		<s-heading fontSize='large'>{title}</s-heading>
    </HomeButtonContainer>
}

export default HomeButton

const HomeButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ebebeb;
  padding: 8px;
  border-radius: 4px;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background: #ebebeb;
  }
`